import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Guest, ResultWithEntity } from '../models';
import { Person } from '../models/person.model';
import moment from 'moment';
import { AdAccount } from '../models/ad-account.model';

@Injectable()
export class GuestService {
  private url = 'api/guests';

  constructor(private http: HttpClient) { }

  resetGuestAttemptCount(guestId: number) {
    return this.http.put<any>(`${this.url}/resetAttempts/${guestId}`, null);
  }

  sendPasswordResetEmail(iNumber: string) {
    return this.http.post<null>(`${this.url}/${iNumber}/passwordReset`, null);
  }

  checkIfActiveDirectoryAccountExists(iNumber: string) {
    return this.http.get<AdAccount>(`${this.url}/${iNumber}/activeDirectoryExists`);
  }

  getPotentialMatchingIdentities(surname: string, restOfName: string, birthdate: string) {
    const formatebirthdate = this.formatDate(birthdate);
    return this.http.get<Person[]>
      (`${this.url}/matches?surname=${surname}&restOfName=${restOfName}&birthdate=${formatebirthdate}`);
  }

  updateGuest(guest: Guest): Observable<ResultWithEntity<Guest>> {
    return this.http.post<ResultWithEntity<Guest>>(`${this.url}`, guest);
  }

  private formatDate(date: string) {
    return moment(date).format('MM-DD-YYYY');
  }
}